import api from ".";
import cookiesModifier from "../utils/cookies";

import { IAction } from "../types/action";

export const getActions = async () => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.get('actions');
        return res.data as IAction[];
    } catch (error) {
        throw error;
    }
}

export const createAction = async (data: IAction) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post('actions', data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateAction = async (data: IAction) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    const { id, ...record } = data;
    try {
        const res = await api.patch(`actions/${id}`, record);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteAction = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.delete(`actions/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}